<template>
    <DraggableDividedLayout v-model="PlannerResourceListWidth" :minValue="10" :maxValue="45">

        <template v-slot:col1>
            <v-list v-if="resourceList && resourceList.length" class="py-0" style="height: 100%;">
                <v-list-item :to="{ name: $route.name, query: { resource: undefined } }" exact
                    exactActiveClass="activeResource" :class="$route.query.resource || 'activeResource'" class="resource"
                    link dense style="border-bottom: 1px solid rgb(205, 205, 205);">
                    <v-list-item-content class="py-0">
                        <v-list-item-title>
                            <v-row no-gutters align="center">
                                <v-col cols="0"> All users </v-col>
                                <v-col cols="auto">
                                    <CardBadge color="primary darken-1" :count="appointmentList.length" />
                                </v-col>
                            </v-row>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-for=" item  in  resourceList " :key="item.id"
                    :to="{ name: $route.name, query: { resource: item.id } }" exact exactActiveClass="activeResource"
                    class="resource" link dense style="border-bottom: 1px solid rgb(220, 220, 220);">
                    <v-list-item-content class="py-0">
                        <v-list-item-title>
                            <v-row no-gutters align="center">
                                <v-col cols="0"> {{ item.name }} </v-col>
                                <v-col cols="auto">
                                    <CardBadge color="primary lighten-1"
                                        :count="(filterAppointmentsByResource(item.id)).length" />
                                </v-col>
                            </v-row>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <template v-else>
                <div class="pa-3">
                    No resources
                </div>
            </template>
        </template>

        <template v-slot:col2>
            <v-progress-linear v-if="loading" rounded indeterminate height="2" absolute
                style="left: 0px;"></v-progress-linear>
            <v-list v-for="(date, index) in dateHeaders" :key="'date-' + index" class="py-0"
                style="background-color: transparent;">
                <v-list-item dense style="border-top: 1px solid rgb(190, 190, 190); background-color: #efefef;">
                    <!-- background-color: #00000012; -->
                    {{ date.text }}
                </v-list-item>
                <template v-if="date.appointments && date.appointments.length">
                    <template v-for="appointment in  date.appointments ">
                        <!--
                        <AppointmentListItem v-if="!showAsJobs && (!hideAbsence || appointment.JobId)"
                            :key="'appointment-' + appointment.Id" :appointment="appointment" :showSubject="true"
                            style="background-color: white;">
                        </AppointmentListItem>
                        -->
                        <EventListItem
                            v-if="!showAsJobs && (!hideAbsence || appointment.JobId) && (!hideCompletedJobs || (appointment.JobId && appointment.JobStatus.Id < 50))"
                            :event="appointment" :key="'appointment-' + appointment.Id"
                            @click="$emit('eventDialog', { eventRecord: { id: appointment.Id, jobId: appointment.JobId } });">
                        </EventListItem>
                        <LazyJobLi
                            v-if="showAsJobs && appointment.JobId && (!hideCompletedJobs || appointment.JobStatus.Id < 50)"
                            :key="'job-' + appointment.Id" :jobId="appointment.JobId">
                        </LazyJobLi>
                    </template>
                </template>
                <template v-else>
                    <p class="pl-4 py-2 mb-0">
                        No appointments
                    </p>
                </template>
            </v-list>
        </template>

    </DraggableDividedLayout>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import LazyJobLi from "@/views/planning/LazyJobListItem.vue";
import { DateHelper } from "@bryntum/schedulerpro";
//import AppointmentListItem from "@/components/ListItems/AppointmentListItem.vue";
import CardBadge from "@/components/Buttons/CardBadge.vue";
import EventListItem from "@/components/ListItems/EventListItem.vue";
import DraggableDividedLayout from "@/views/planning/DraggableDividedLayout.vue";

export default {
    name: 'EventList',
    props: {},
    components: {
        LazyJobLi,
        //AppointmentListItem,
        EventListItem,
        DraggableDividedLayout,
        CardBadge,
    },
    mixins: [clientAPI],

    data() {
        return {
            loading: false,
            resourceList: null,
            appointmentList: [],
            startDate: new Date(new Date().setHours(0, 0, 0, 0)),
            endDate: new Date(new Date().setHours(23, 59, 59, 0)),
        };
    },

    mounted() {
        this.initLists();
    },

    methods: {
        async initLists() {
            this.loading = true;
            this.getSchedulerStartAndEnd(this.calendarStartDate);
            this.resourceList = await clientAPI.methods.getResourceList();
            this.appointmentList = await clientAPI.methods.getAppointmentsByDateOrRange(this.startDate, this.endDate, true);
            this.loading = false;
        },

        getSchedulerStartAndEnd(date) {
            if (!date) { date = new Date(); }
            var mode = this.plannerScope;
            var onlyworkhours = this.limitToWorkHours;

            if (mode == 'QDay') {
                this.startDate = DateHelper.add(DateHelper.clearTime(date), (onlyworkhours ? 8 : 0), 'hour'); //clear hours then set starttime correctly
                this.endDate = DateHelper.add(DateHelper.clearTime(date), (onlyworkhours ? 20 : 23.999), 'hour'); //clear hours then set endtime correctly
            }
            else if (mode == 'QWeek') {
                var firstDayOfWeek = 1; //1 is monday, 2 is tuesday and so on...
                var weekLength = onlyworkhours ? 5 : 7; //defines how many days from start are inculded. (so if firstDayOfWeek is monday and weekLength is 5 it gives monday to friday)
                const startOfWeek = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() + firstDayOfWeek);
                const endOfWeek = new Date(date.getFullYear(), date.getMonth(), startOfWeek.getDate() + (weekLength - 1), 23, 59, 59);
                this.startDate = startOfWeek;
                this.endDate = endOfWeek;
            }
            else if (mode == 'QMonth') {
                const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
                const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59);
                this.startDate = startOfMonth;
                this.endDate = endOfMonth;
            }


        },

        isOnDate(date, appointment) {
            var start = (DateHelper.clearTime(date));
            var end = (DateHelper.add(start, 1, 'day')).getTime();
            start = start.getTime();
            var appstart = new Date(appointment.StartTime).getTime();
            var append = new Date(appointment.EndTime).getTime();
            return (end >= append && start <= appstart)
        },

        filterAppointmentsByResource(id) {
            return this.appointmentList.filter(x => (
                (!this.hideAbsence || (!x.IsAbsence)) &&
                (!this.hideCompletedJobs || (x.JobId && x.JobStatus.Id < 50)) &&
                x.Participants.some(y => y.UserId == id)
            ));
        }
    },

    computed: {
        PlannerResourceListWidth: {
            get() {
                return this.$store.getters["prefrences/Prefrence"]("PlannerResourceListWidth");
            },
            set(update) {
                this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerResourceListWidth", value: update });
            },
        },

        calendarStartDate() {
            return this.$store.getters["plannerstore/CalendarDateStart"];
        },

        plannerScope() {
            return this.$store.getters["prefrences/Prefrence"]("PlannerScope");
        },

        dateHeaders() {
            let Difference_In_Time = this.endDate.getTime() - this.startDate.getTime();
            let Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
            var format = Difference_In_Days ? "ddd D. MMM" : "hh:mm"; //show time if duration less than a day, else show the dates
            var dateArray = new Array();
            var currentDate = this.startDate;
            while (currentDate <= this.endDate) {
                var dateHeader = {
                    text: DateHelper.format(currentDate, format),
                    date: currentDate,
                    appointments: (this.resourceFilteredAppointments && this.resourceFilteredAppointments.length) ? this.resourceFilteredAppointments.filter(x => this.isOnDate(currentDate, x)) : [],
                    collapsed: false,
                }
                dateArray.push(dateHeader);
                currentDate = currentDate.addDays(1);
            }

            return dateArray;
        },

        resourceGroupHeaders() {
            return []
        },

        resourceFilteredAppointments() {
            if (this.filterByResourceId) {
                return this.filterAppointmentsByResource(this.filterByResourceId);
            }
            else {
                return this.appointmentList;
            }
        },

        filterByResourceId() {
            return this.$route.query.resource;
        },

        Mode() {
            return this.$store.getters["prefrences/Prefrence"]("PlannerMode");
        },
        listMode() {
            return this.Mode == 'List';
        },

        showAsJobs: {
            get() {
                return this.$store.getters["prefrences/Prefrence"]("PlannerListShowAsJobs");
            },
            set(update) {
                this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerListShowAsJobs", value: update });
            },
        },
        hideCompletedJobs: {
            get() {
                return this.$store.getters["prefrences/Prefrence"]("PlannerListHideCompletedJobs");
            },
            set(update) {
                this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerListHideCompletedJobs", value: update });
            },
        },
        hideAbsence: {
            get() {
                return this.$store.getters["prefrences/Prefrence"]("PlannerListHideAbsence");
            },
            set(update) {
                this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerListHideAbsence", value: update });
            },
        },
    },

    watch: {
        calendarStartDate: function () {
            if (this.listMode) {
                this.initLists();
            }
        },

        plannerScope: function () {
            if (this.listMode) {
                this.initLists();
            }
        },

        listMode: function (val) {
            if (val) {
                this.initLists();
            }
        }
    },
};
</script>


<style lang='scss' scoped>
.resource {
    background-color: rgb(246, 246, 246);
}

.activeResource {
    border: 2px solid var(--v-primary-base) !important;
    background-color: white;
    border-right: none !important;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
}

.activeResource:before {
    background-color: transparent;
}
</style>